export enum GroupStatus {
  Uninitialized = 'UNINITIALIZED',
  Active = 'ACTIVE',
  Onboarding = 'ONBOARDING',
}
